import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser'

export const Modal = () => {


    const [modal, setmodal] = useState('open');
    const wasClosed = sessionStorage.getItem('modal');
    const [modalInfo, setModalInfo] = useState([]);

    const handleClose = () => {
        sessionStorage.setItem('modal', 'close');
        setmodal('close');
    };


    useEffect(() => {
        const modalEl = document.querySelector('.modalBackdrop');
        if (modal == 'open') {
            modalEl.style.display = 'block';
        } else {
            modalEl.style.display = 'none';
        }
        if (wasClosed != 'close') {
            modalEl.style.display = 'block';
        } else {
            modalEl.style.display = 'none';
        }
    });


    useEffect(() => {
        fetch("/getModal")
            .then(res => res.json())
            .then(result => {
                setModalInfo(result);
            });
    }, []);





    return (
        /*  
        <div className="modalBackdrop">
             <div className="modalScreen">
                 <p className="title">Para el cuidado de sus datos personales y la prevención de fraudes, le sugerimos tener presente los siguientes consejos de seguridad:</p>
                 <ul>
                     <li><p className="li-1 mb-octa"></p>No dé información personal o financiera a través de llamadas, mensajes o correos electrónicos.</li>
                     <li><p className="li-2 mb-octa"></p>No realice transferencias bancarias a cuentas de particulares. Los depósitos de dinero serán solicitados únicamente a cuentas bancarias que se encuentren a nombre de los concesionarios oficiales y/o FCA de Ahorro.</li>
                     <li><p className="li-3 mb-octa"></p>En caso de recibir llamadas de promociones, se debe corroborar siempre con FCA de Ahorro llamando a los números oficiales establecidos.</li>
                     <li><p className="li-4 mb-octa"></p>Si se recibe un e-mail que parezca sospechoso, no haga ‘clic’ para no caer en una trampa de ‘phishing’. Este es un método muy utilizado por los ciberdelincuentes para que la víctima revele sus contraseñas o datos de tarjetas de crédito y cuentas bancarias. Lo hacen mediante correos electrónicos fraudulentos que lo redirigen a un sitio web falso donde solicitan información sensible.</li>
                 </ul>
                 <button className="btn-modal" onClick={handleClose}>ACEPTAR</button>
             </div>
         </div> 
        */


        <div className="modalBackdrop">
            <div className="modalScreen">
                <p className="title">{(modalInfo.titulo) ? modalInfo.titulo : ''}</p>
                <ul>
                    <li>
                        {ReactHtmlParser((modalInfo.descripcion) ? modalInfo.descripcion : '')}
                    </li>
                </ul>
                <button className="btn-modal" onClick={handleClose}>ACEPTAR</button>
            </div>
        </div>
    )
}
